<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2ky30m/tc-custom/9781504097628.jpg?1737806200677" alt="This image is the cover for the book Man in the Queue, The Inspector Grant Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Man in the Queue, The Inspector Grant Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>This locked-room mystery, “</b><b>solid proof for the unreliability of circumstantial evidence” will have readers “give thanks” for the British crime classic (<i>Kirkus Reviews</i>).</b><br/>  <br/> A long line of people stand outside a London West End Theatre, hopeful to nab standing room tickets for one of the last performances of an acclaimed actress. The crowd surges forward eagerly, all except for one man, who sinks to the ground, dead. The silver stiletto dagger plunged in his back sends a ripple of horror through the spectators, none of whom managed to spot the killer.<br/>  <br/> It’s up to Insp. Alan Grant of Scotland Yard to solve the puzzle of how a man was targeted among so many potential witnesses—an investigation that will have the astute detective tracking clues from London to the Scottish highlands, all in the name of bringing a murderer to justice.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Josephine Tey
      </h2>
      
      <p class="authorDescription body article">Josephine Tey was the pseudonym for Scottish author Elizabeth MacKintosh. She wrote six mystery novels featuring Scotland Yard&rsquo;s Insp. Alan Grant. Several of her books have been made into films or dramatized for radio. Her novel <I>The Daughter of Time</I> was chosen by the Crime Writers&rsquo; Association in 1990 as the greatest mystery novel of all time.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress.com/Open Road
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?18cf1840